export const archives = $axios => ({
  create: workflowId => $axios.$post(`/workflows/${workflowId}/archive`),
  delete: workflowId => $axios.$delete(`/workflows/${workflowId}/archive`),
});
